module.exports = __webpack_public_path__ + "ceec7ec984e8da034d4fbac1ec2f1dd2.png";